
'use client';

// import { useTranslation } from 'react-i18next';
import React from 'react';
import { Container } from 'react-bootstrap';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import {useTranslations} from 'next-intl';
// import banner from "@/app/assets/images/banner.png";
// import banner2 from "@/app/assets/images/banner2.png";
// import banner3 from "@/app/assets/images/banner3.png";

import CategoryCard, { Category } from '@/components/catelog/category-card';
import ItemCard from '@/components/catelog/item-card';
import ComboCard from '@/components/catelog/combo-card';
import SearchBar from '@/components/search';
import Navbar from '@/components/navbar';

import styles from "@/styles/menu.module.scss";
import FloatCart from '@/components/payments/cart-float';

import useStore from '@store/index';
import PreloaderComponent from '@/components/preloader';
import { ItemObj } from '../modals/order-details-sheet';
import Image from 'next/image';
import BannerPopupModal from '@/components/modals/BannerPopupModal';
import { timezoneDateConvert } from '_services/common.service';
// import { ArrowLeft, ChevronRight } from 'react-feather';

const dealsStyles: Record<number, string> = {
  0: styles.dealStyles1,
  1: styles.dealStyles2,
  2: styles.dealStyles3,
  3: styles.dealStyles4,
  4: styles.dealStyles5,
  5: styles.dealStyles6,
}

/* const bannerImages = [
  banner,
  banner2,
  banner3,
  banner,
  banner2,
  banner3,
]; */

function HomeComponent({ categories, promos, deals, justLaunchedItems, topChoices }: {
  categories: Category[],
  promos: PromoBanner[],
  deals: Category[],
  justLaunchedItems: ItemObj[],
  topChoices: ItemObj[]
}) {


  const t = useTranslations('HomePage');

  const { hasHydrated, companyDetails, setPromoBanners, orderServeDetails, showBannerPopup, setShowBannerPopup, promoBanners, isServiceModalOpen } = useStore((state) => state);
  const [showHint, setShowHint] = React.useState(true);
  const [swiperInstance, setSwiperInstance] = React.useState<SwiperClass | null>(null);
  const [eligiblePromos, setEligiblePromos] = React.useState<PromoBanner[]>([]);
  const [showPromoModal, setShowPromoModal] = React.useState(false);
  const [selectedPromo, setSelectedPromo] = React.useState<PromoBanner | null>(null);
  const [hasServiceModalBeenOpened, setHasServiceModalBeenOpened] = React.useState(false);
  const [isBannerGateReady, setIsBannerGateReady] = React.useState(false);
  const [hasShownBannerForThisVisit, setHasShownBannerForThisVisit] = React.useState(() => {
    // Check if banner was already shown in this browser session
    if (typeof window !== 'undefined') {
      return sessionStorage.getItem('bannerShown') === 'true';
    }
    return false;
  });


  React.useEffect(() => {
    if (promos && promos.length > 0) {
      setPromoBanners(promos);
    }
  }, [promos, setPromoBanners]);

  // Check for banner popup when service is selected or after service modal is shown
  React.useEffect(() => {
    if (isServiceModalOpen) {
      setHasServiceModalBeenOpened(true);
      setIsBannerGateReady(false);
      return;
    }

    if (hasServiceModalBeenOpened) {
      setIsBannerGateReady(true);
      return;
    }

    // Fallback for refreshes where service is already selected and modal does not reopen.
    if (orderServeDetails) {
      const timer = window.setTimeout(() => {
        setIsBannerGateReady(true);
      }, 800);

      return () => {
        window.clearTimeout(timer);
      };
    }
  }, [isServiceModalOpen, hasServiceModalBeenOpened, orderServeDetails]);

  React.useEffect(() => {
    if (!orderServeDetails || !promoBanners || promoBanners.length === 0 || hasShownBannerForThisVisit || isServiceModalOpen) {
      return;
    }

    // Wait for service modal flow when it appears, with fallback for refresh scenarios.
    if (!isBannerGateReady) {
      return;
    }

    const now = new Date();
    const eligible = promoBanners.filter((banner) => {
      const startDate = new Date(timezoneDateConvert({ 
        utcDate: (banner.popupStartDate || ''), 
        timezone: (companyDetails?.timeZone || ''), 
      }));
      const endDate = new Date(timezoneDateConvert({ 
        utcDate: (banner.popupEndDate || ''), 
        timezone: (companyDetails?.timeZone || ''), 
      }));
      if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
        return false;
      }
      return now >= startDate && now <= endDate;
    });

    if (eligible.length > 0) {
      setEligiblePromos(eligible);
      setShowBannerPopup(true);
      setHasShownBannerForThisVisit(true);
      // Store in sessionStorage to persist across page refreshes but clear on browser close
      if (typeof window !== 'undefined') {
        sessionStorage.setItem('bannerShown', 'true');
      }
    }
  }, [orderServeDetails, promoBanners, companyDetails?.timeZone, setShowBannerPopup, hasShownBannerForThisVisit, isServiceModalOpen, isBannerGateReady]);

  if (!hasHydrated) {
    return <PreloaderComponent />; // Prevent rendering until store is hydrated
  }

  // const handlePromoClick = (promo: string, index: number) => {
  //   console.log('Clicked promo:', promo, 'at index:', index);
  // };

  // console.log(categories, promos, deals, justLaunchedItems, topChoices);
  // console.log(deals);
  

  return (<>
    <Navbar isHomePage={true}/>

    <main className={`${styles.home} ${styles.main}`}>

      <Container className={styles.menuContainer}>
        {/* SEO H1 - Hidden visually but present for search engines */}
        <h1 style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', overflow: 'hidden' }}>
          {companyDetails?.name || 'Farmhouse Pizza - Manjimup'}
        </h1>

        {/* Search Bar */}
        <SearchBar />

        {/* Categories */}
        {/* <div className={styles.categories} >
            <Swiper
              spaceBetween={12}
              slidesPerView={'auto'}
              // breakpoints={{
              //   0: { slidesPerView: 3 },
              //   464: { slidesPerView: 3 },
              //   768: { slidesPerView: 1 },
              //   1024: { slidesPerView: 1 },
              // }}
              navigation={false}
              pagination={{ clickable: true }}
              draggable={true}
              freeMode={true}
              className={styles.categoryCarousel}
            >
              {categories.map((category, index) => (
                <SwiperSlide key={index} lazy={false} className={styles.categoryCarouselItem}>
                  <CategoryCard category={category} cardId={`category-link-${index}`} />
                </SwiperSlide>
              ))}
            </Swiper>
        </div> */}

        {/* <div className={styles.categories}>
          <div className={styles.scrollHintWrapper}>
            <Swiper
              spaceBetween={12}
              slidesPerView={'auto'}
              navigation={false}
              pagination={{ clickable: true }}
              draggable={true}
              onReachEnd={() => setShowHint(false)}
              onReachBeginning={() => setShowHint(true)}
              onFromEdge={(swiper) => {
                setShowHint(!swiper.isEnd && !swiper.isBeginning);
              }}
              onSwiper={(swiper) => {
                setSwiperInstance(swiper);
                setShowHint(!swiper.isEnd && !swiper.isBeginning);
              }}
              onSlideChange={(swiper) => {
                if (swiper.isEnd) {
                  setShowHint(false);
                } else {
                  setShowHint(!swiper.isBeginning);
                }
              }}
              className={styles.categoryCarousel}
            >
              {categories.map((category, index) => (
                <SwiperSlide key={index} className={styles.categoryCarouselItem}>
                  <CategoryCard category={category} cardId={`category-link-${index}`} />
                </SwiperSlide>
              ))}
            </Swiper>
            {showHint && (
              <div 
                className={styles.scrollHintDiv} 
                onClick={() => {
                  if (swiperInstance) {
                    swiperInstance.slideTo(swiperInstance.slides.length - 1);
                  }
                  setShowHint(false);
                }}
              >
                <div className={styles.scrollHint}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={styles.scrollHintIcon}>
                    <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" />
                  </svg>
                </div>
              </div>
            )}
          </div>
        </div> */}

       <div className={styles.categories}>
  <div className={styles.scrollHintWrapper}>
    <Swiper
      spaceBetween={0}
      slidesPerView={'auto'}
      navigation={false}
      pagination={{ clickable: true }}
      draggable={true}
      onReachEnd={() => setShowHint(false)}
      onReachBeginning={(swiper) => {
        setShowHint(swiper.isBeginning && !swiper.isEnd);
      }}
      onFromEdge={(swiper) => {
        setShowHint(!swiper.isEnd && !swiper.isBeginning);
      }}
      onSwiper={(swiper) => {
        setSwiperInstance(swiper);
        setShowHint(swiper.isBeginning && !swiper.isEnd);
      }}
      onSlideChange={(swiper) => {
        if (swiper.isEnd) {
          setShowHint(false);
        } else if (swiper.isBeginning) {
          setShowHint(true);
        } else {
          setShowHint(true);
        }
      }}
      className={styles.categoryCarousel}
    >
      {categories.map((category, index) => (
        <SwiperSlide key={index} className={styles.categoryCarouselItem}>
          <CategoryCard category={category} cardId={`category-link-${index}`} />
        </SwiperSlide>
      ))}
    </Swiper>
    {showHint && (
      <div 
        className={styles.scrollHintDiv} 
        onClick={() => {
          if (swiperInstance) {
            swiperInstance.slideTo(swiperInstance.slides.length - 1);
          }
          setShowHint(false);
        }}
      >
        <div className={styles.scrollHint}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={styles.scrollHintIcon}>
            <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" />
          </svg>
        </div>
      </div>
    )}
  </div>
</div>

        <div className={styles.promosAndDeals}>
            {(promos && promos.length > 0) && <div className={styles.carouselContainer}>
            <Swiper
              spaceBetween={16}
              slidesPerView={1}
              breakpoints={{
                0: { slidesPerView: 1 },
                464: { slidesPerView: 1 },
                768: { slidesPerView: 1 },
                1024: { slidesPerView: 1 },
                1440: { slidesPerView: promos.length === 1 ? 1 : 2 }
              }}
              modules={[Navigation, Pagination, Autoplay]}
              navigation={false}
              pagination={{ clickable: true }}
              draggable={true}
              loop={true}
              className={styles.promoCarousel}
              autoplay={{ delay: 2500, disableOnInteraction: false, pauseOnMouseEnter: true }}
            >
              {promos.map((promo, index) => (
              <SwiperSlide key={index} lazy={false} className={styles.categoryCarouselItem}>
                <div 
                  className={styles.promoCard}
                  onClick={() => {
                    setSelectedPromo(promo);
                    setShowPromoModal(true);
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <Image 
                    src={promo.imageUrl} 
                    alt={promo.title} 
                    width={600} height={350} 
                    layout="responsive" 
                    objectFit="cover"
                    onError={(e) => { (e.target as HTMLImageElement).src = '/images/placeholder.png'; }}
                    />
                </div>
              </SwiperSlide>
              ))}
            </Swiper>
          </div>}

          {/* test banners */}
          {/* {(bannerImages && bannerImages.length > 0) && <div className={styles.carouselContainer}>
            <Swiper
              spaceBetween={16}
              slidesPerView={1}
              breakpoints={{
                0: { slidesPerView: 1 },
                464: { slidesPerView: 1 },
                768: { slidesPerView: 1 },
                1024: { slidesPerView: 1 },
                1440: { slidesPerView: bannerImages.length === 1 ? 1 : 2 }
              }}
              modules={[Navigation, Pagination, Autoplay]}
              navigation={false}
              pagination={{ clickable: true }}
              draggable={true}
              loop={true}
              className={styles.promoCarousel}
              autoplay={{ delay: 2500, disableOnInteraction: false, pauseOnMouseEnter: true }}
            >
              {bannerImages.map((promo, index) => (
              <SwiperSlide key={index} className={styles.categoryCarouselItem}>
                <div className={styles.promoCard}>
                  <Image src={promo} alt={`bannerImages ${index}`} width={600} height={350} layout="responsive" objectFit="cover" />
                </div>
              </SwiperSlide>
              ))}
            </Swiper>
          </div>} */}


          {deals.length > 0 && <div className={styles.deals}>
            {deals.map((deal, index: number) => (
              deal.subCategories && deal.subCategories.length > 0 && deal.subCategories.map((subCategory: Category, subIndex: number) => (
                <React.Fragment key={subIndex}>
                  <ComboCard bannerCount={promos && promos.length} deal={subCategory} comboId={`deal-${index}-sub-${subIndex}-link`} className={dealsStyles[subIndex]} />
                </React.Fragment>
              ))
            ))}
          </div>}
        </div>

        {(justLaunchedItems && justLaunchedItems.length > 0) && <div className={styles.pizzaSection}>
          <h2>{t('JUST_LAUNCHED')}</h2>
          <div className={styles.pizzaGrid}>
            {justLaunchedItems.map((pizza, index) => (
              <React.Fragment key={index}>
                  <ItemCard pizza={pizza} itemId={`justlaunched-item-${index}-link`} />
              </React.Fragment>
            ))}
          </div>
        </div>}

        {(topChoices && topChoices.length > 0) && <div className={styles.pizzaSection}>
          <h2>{t('TOP_CHOICES')}</h2>
          <div className={styles.pizzaGrid}>
            {topChoices.map((pizza, index) => (
              <React.Fragment key={index}>
                <ItemCard pizza={pizza} itemId={`topchoice-item-${index}-link`} />
              </React.Fragment>
            ))}
          </div>
        </div>}
        
      </Container>
      <div className={styles.menuBottomStyles}><div/>
        {/* Cart Float */}
        <FloatCart />
      </div>

      {/* Banner Popup Modal */}
      <BannerPopupModal
        show={showBannerPopup && !isServiceModalOpen}
        onHide={() => setShowBannerPopup(false)}
        banners={eligiblePromos}
        timeZone={companyDetails?.timeZone || ''}
      />

      {/* Promo Card Click Modal */}
      {selectedPromo && (
        <BannerPopupModal
          show={showPromoModal}
          onHide={() => {
            setShowPromoModal(false);
            setSelectedPromo(null);
          }}
          banners={[selectedPromo]}
          showTitle={false}
          timeZone={companyDetails?.timeZone || ''}
        />
      )}

    </main>
  </>);
}

export default HomeComponent;
